import { render } from "./Styleguide-Layout-Reuse.vue?vue&type=template&id=8d5b23f8"
import script from "./Styleguide-Layout-Reuse.vue?vue&type=script&lang=js"
export * from "./Styleguide-Layout-Reuse.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__